import styles from './PaymentSteps.module.css';
import { useLocation, useSearchParams, useNavigate } from 'react-router-dom';

function PaymentSteps() {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isCreditCardPurchase =
    searchParams.get('isCreditCardPurchase') === 'true';
  const steps = [
    {
      pathname: '/',
      isComplete: location.pathname !== '/',
      text: 'Choose Payment Method'
    },
    {
      pathname: isCreditCardPurchase ? '#' : '/select-currency',
      isComplete: location.pathname === '/confirm',
      text: 'Payment Details'
    },
    {
      pathname: '/confirm',
      text: 'Review'
    }
  ];

  return (
    <div className={styles.paymentStepsContainer}>
      <ol className={`bodySmReg ${styles.stepsList}`}>
        {steps.map((step, i) => (
          <li
            key={i}
            className={`${styles.step} ${
              step.isComplete ? styles.stepComplete : ''
            } ${
              step.pathname === location.pathname ? styles.stepCurrent : ''
            } ${step.pathname === '#' ? styles.stepDisabled : ''}`}
            onClick={() => {
              navigate({
                pathname: step.pathname,
                search: '?' + searchParams
              });
            }}
          >
            <span className={styles.stepText}>{step.text}</span>
          </li>
        ))}
      </ol>
    </div>
  );
}

export default PaymentSteps;
